<div class="content-body mb-4">
  <p class="header-text d-flex justify-space-between align-items-center">
    {{ headerText }}
    <button
      mat-button
      class="header-text-close d-flex align-items-center"
      disableRipple
      (click)="onCloseClick()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </p>
  <div class="alert-message mb-10" *ngIf="isViewPermission$ | async">
    <mat-icon class="material-icons-outlined">error_outline</mat-icon>
    {{ commonNotificationText.ViewOnlyAccessMessage }}
  </div>

  <form [formGroup]="trusteesReportForm" class="p-0">
    <div class="d-flex gap-30 justify-space-between">
      <div class="content-right-button d-flex align-items-center gap-10 mb-1">
        <span class="fw-bold">Period: <span  class="text-danger-300">*</span></span>
        <mat-form-field class="w-200">
          <mat-select
            panelClass="mat-select-position"
            [disableOptionCentering]="true"
            formControlName="accountingPeriod"
            (selectionChange)="onAccountPeriodChange();changePeriod()"
          >
            <mat-option
              *ngFor="let option of periodicDateList"
              [value]="option.id"
              title=" {{ option.fromDate | date: 'dd-LLL-yyyy' }} -
              {{ option.toDate | date: 'dd-LLL-yyyy' }}"
            >
              {{ option.fromDate | date: "dd-LLL-yyyy" }} -
              {{ option.toDate | date: "dd-LLL-yyyy" }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="!isTrusteeReport" class="content-right-button d-flex align-items-center gap-10 mb-1">
        <span class="fw-bold">Examiner Name: <span  class="text-danger-300">*</span></span>
        <mat-form-field class="w-200">
          <mat-select
            panelClass="mat-select-position"
            [disableOptionCentering]="true"
            formControlName="name"
            required
          >
          <mat-option value="">Select</mat-option>
            <mat-option *ngFor="let examiner of examiners" [value]="examiner.id" [title]="examiner.name">{{ examiner.name }} {{examiner?.lastName}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="!isTrusteeReport" class="content-right-button d-flex align-items-center gap-10 mb-1">
        <span class="fw-bold">Date: <span  class="text-danger-300">*</span></span>
        <mat-form-field appearance="fill">
          <input  required matInput formControlName="date" [matDatepicker]="daDatePicker" autocomplete="off"/>
          <mat-datepicker-toggle matSuffix [for]="daDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #daDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    </form>
    <div *ngIf="((charityType === 3) && isTrusteeReport)">
      <div class="d-flex">
        <div class="notes-view" *ngIf="iscompanyRegistered">
          <div *ngFor="let report of trusteeReports" class="d-flex align-items-center justify-space-between gap-10">
              <mat-checkbox [(ngModel)]="report.isChecked" (change)="onCheckboxClick($event, report, 'trustees')">
                <div class="d-flex">
                  <p class="mb-0 clamp" title="{{ report.title }}">{{ report.title }}</p>
                </div>
              </mat-checkbox>
              <button class="edit-icn" mat-button disableRippl [disabled]="!report.isChecked">
                <mat-icon [ngStyle]="{'cursor': !report.isChecked ?  'none' : 'pointer'}" (click)="getTrusteesDataById(report.type)" fontSet="material-icons-outlined">edit</mat-icon>
              </button>
          </div>
        </div>
        <div>
          <div class="content-body inner-table-html trustee-report p-0" style="min-height: 100%;">
        <div *ngIf="htmlContent" [innerHtml]="transformYourHtml()"></div>
      </div>
          <!-- Show preview here -->
        </div>
      </div>
    </div>
    <ng-container *ngIf="((charityType !== 3) && isTrusteeReport) || !isTrusteeReport">
    <form [formGroup]="trusteesReportForm" class="p-0">
    <div [ngClass]="(isViewPermission$ | async) ? 'is-readonly' : ''">
      <p class="fw-bold">{{ headerText }}</p>
      <div>
        <ejs-richtexteditor
          [toolbarSettings]="
            commonService.syncfusionRichTextEditorToolbarSettings
          "
          (actionBegin)="
            commonService.syncfusionRichTextEditorOnActionBegin($event)
          "
          [enableXhtml]="true"
          [toolbarSettings]="commonService.syncfusionRichTextEditorTools"
          formControlName="textbox1"
          [enableHtmlSanitizer]="true"
          [pasteCleanupSettings]="syncfusionRichTextEditorPasteCleanupSettings"
        ></ejs-richtexteditor>
      </div>
    </div>
  </form>
  </ng-container>
</div>
<ng-container *ngIf="((charityType !== 3) &&  isTrusteeReport) || !isTrusteeReport">
<app-buttons
  *ngIf="!(isViewPermission$ | async)"
  [getModuleId]="moduleId"
  (triggerOnSaveClick)="onSave()"
  (triggerOnCancelClick)="onCancel()"
  [saveButtonShow]="true"
>
</app-buttons>
</ng-container>
